import React from 'react'
import Button from '@mui/material/Button'
import { useAssetHolderApiRemoveCitizen } from '../../../api-services/asset-holdings/assetHolderApi'
import { setNotification } from '../../components/ui-widgets/uiWidgetsSlice'
import { useAppDispatch } from '../../../app/hooks'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { type AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import WrongLocationIcon from '@mui/icons-material/WrongLocation'

interface RemoveUsCitizenComponentProps {
  assetHolder: AssetHolderUpdateDto
}

const RemoveUsCitizenComponent = (props: RemoveUsCitizenComponentProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const { assetHolder } = props

  const [apiRemoveUsCitizen] = useAssetHolderApiRemoveCitizen()

  const handleRemoveUsCitizen = (): void => {
    apiRemoveUsCitizen(assetHolder.assetHolderId)
      .unwrap()
      .then(() => {
        dispatch(setNotification({ open: true, severity: 'success', message: 'Member\'s US citizenship status has been removed.' }))
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  const openRemoveUsCitizenDialog = (): void => {
    const choice = window.confirm(
      'Are you sure you want to remove the US Citizenship Status?'
    )
    if (choice) {
      handleRemoveUsCitizen()
    }
  }

  return (
    <React.Fragment>
      <Button
        variant={'outlined'}
        startIcon={<WrongLocationIcon />}
        onClick={openRemoveUsCitizenDialog}
        disabled={!assetHolder.usCitizenStatus.isUsCitizen}
      >
        Remove US Citizen Status
      </Button>
    </React.Fragment>
  )
}

export default RemoveUsCitizenComponent
